import React from 'react';
import './BlogTestimonial.css';

const BlogTestimonial = ({ quote, author, position }) => {
  return (
    <div className="blog-testimonial">
      <div className="testimonial-content">
        <p className="testimonial-quote">{quote}</p>
        <div className="testimonial-author">
          <p className="author-name">{author}</p>
          {position && <p className="author-position">{position}</p>}
        </div>
      </div>
    </div>
  );
};

export default BlogTestimonial;
